import React from 'react';
import moment from 'moment';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { sessionActions } from '../../store/actions';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/footer';
import '../../static/css/styles.css';
import { constants } from '../../Constants';
import Swal from 'sweetalert2';
import Select from 'react-select';
import ReactPaginate from 'react-paginate';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import UpdateNaruteOfIssueModal from '../../components/UpdateNatureOfIssueModal';
import * as fileSaver from 'file-saver';
import * as XLXS from "xlsx";

let selectStatusOptions = []
let selectNatureOfIssue = []
let selectedNaturesPayload = {
	appointment_id: "",
	list_nature_of_issues: [],
	other_issue_text: ""
}

let rdrElements;
let rdrMonthAndYearWrapper;

const selectStyles = {
	option: (provided, state) => ({
		...provided,
		borderBottom: constants.SELECT_STYLES_BORDER_BOTTOM,
		color: state.isSelected ? constants.SELECT_STYLES_IS_SELECT_COLOR : state.isDisabled ? constants.SELECT_STYLES_IS_DISABLED_COLOR : "",
		backgroundColor: state.isSelected ? constants.SELECT_STYLES_IS_SELECTED_BG_COLOR : "",
		textAlign: constants.SELECT_STYLES_TEXT_ALIGN,
		cursor: state.isDisabled ? constants.SELECT_STYLES_IS_DISABLED_CURSOR : constants.SELECT_STYLES_DEFAULT_CURSOR,

	}),
	container: base => ({
		...base,
		width: constants.SELECT_STYLES_CONTAINER_WIDTH,
	}),
	control: (base) => ({
		...base,
		height: constants.SELECT_STYLES_CONTROL_HEIGHT,
		fontSize: constants.SELECT_STYLES_CONTROL_FONT_SIZE,
		borderRadius: constants.SELECT_STYLES_CONTROL_BORDER_RADIUS,
		width: constants.SELECT_STYLES_CONTROL_WIDTH,
		textAlign: constants.SELECT_STYLES_CONTROL_TEXT_ALIGN,
		cursor: constants.SELECT_STYLES_CONTROL_CURSOR
	}),
	valueContainer: base => ({
		...base,
		padding: 0,
		paddingLeft: 2
	})
};

class SessionsHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sessionHistory: {},
			sessionStatus: {},
			natureIssue: [],
			is_csv_download: false,
			session_csv: '',
			natureSelectedIssue: [],
			natureIssueOther: '',
			sessionHistoryStatus: { loading: false, sessionStatus: false },
			currentStatus: {},
			currentPage: 1,
			isMobileScreen: false,
			isDateRangeSelected: false,
			isCalendarVisible: false,
			range: [
				{
					startDate: null,
					endDate: null,
					key: 'selection'
				}
			],
			isModalOpen: false,
			isOtherSelected: false,
			sessionIndexForModal: ''
		};
		this.handleOtherInputChange = this.handleOtherInputChange.bind(this)
	}

	componentDidMount() {
		this.showSessions()
		this.props.getSessionStatus()
		this.props.getNatureIssues()
		window.addEventListener("resize", this.resize.bind(this));
		this.resize()

		const rdrElement = document.querySelector(".rdrMonths");
		if (rdrElement) {
			rdrElement.classList.add("showFlex");
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resize.bind(this));
	}

	resize() {
		this.setState({ isMobileScreen: window.innerWidth <= 545 });
	}


	componentWillReceiveProps(nextProps) {
		selectStatusOptions = []
		selectNatureOfIssue = []
		if (nextProps.sessionCSVHistory.session_csv && this.state.is_csv_download) {
			this.handleCSVExport(nextProps.sessionCSVHistory.session_csv)
			this.setState({ session_csv: nextProps.sessionCSVHistory.session_csv })
		}
		this.setState({ sessionHistory: nextProps.sessionHistory, natureIssue: nextProps.natureIssue.loading, sessionStatus: nextProps.sessionStatus, sessionHistoryStatus: { ...nextProps.sessionHistoryStatus } })

		this.state.natureIssue.length && this.state.natureIssue.map(nature => {
			selectNatureOfIssue.push({ value: nature.code, label: nature.text })
		})
		this.state.sessionStatus.sessionStatus && this.state.sessionStatus.sessionStatus.map((value, index) => {
			if (value === "Incomplete" || value === "Rescheduled/ cancelled") {
				selectStatusOptions.push({ value: index, label: value, shouldBeDisplayed: false })
			} else {
				selectStatusOptions.push({ value: index, label: value })
			}
		})
		if (nextProps.sessionHistoryStatus.sessionStatus == true) { // the sessionStatus is true if it updated successfully
			this.updateStatusOption(this.state.currentStatus.index, this.state.currentStatus.value)
		}
	}

	updateStatusOption = (index, value) => { // update the status option if api status is success
		if (index !== undefined && (this.state.currentStatus && this.state.currentStatus.isSelected == true)) {
			this.setState((prevState) => {
				(
					prevState.sessionHistory && prevState.sessionHistory.session && prevState.sessionHistory.session.results &&
					(prevState.sessionHistory.session.results[index].appointment_status = value),

					prevState.currentStatus && prevState.currentStatus.isSelected &&
					(prevState.currentStatus.isSelected = false))
			})
		}
	}

	openModalHandler = (index) => {
		this.setState({ isModalOpen: true, sessionIndexForModal: index, isOtherSelected: false, natureIssueOther: '' })
		selectedNaturesPayload.other_issue_text = ''
		let selectedNatures = []
		if (this.state.sessionHistory.session.results[index]) {
			this.state.sessionHistory.session.results[index].appointment_nature_of_issue.map(
				appointment => {
					if (appointment.other_issue_text) {
						this.setState({ natureIssueOther: appointment.other_issue_text, isOtherSelected: true })
						selectedNaturesPayload.other_issue_text = appointment.other_issue_text
					} else if (this.state.natureIssueOther) {
						this.setState({ isOtherSelected: true, natureIssueOther: this.state.natureIssueOther })
						selectedNaturesPayload.other_issue_text = this.state.natureIssueOther
					}
					if (appointment.nature_of_issue) {
						selectedNatures.push({ value: appointment.nature_of_issue.text, label: appointment.nature_of_issue.text })
						selectNatureOfIssue.splice(selectNatureOfIssue.findIndex(select => select.value.toLocaleLowerCase() === appointment.nature_of_issue.text.toLocaleLowerCase()), 1)
					} else {
						selectedNatures.push(appointment)
						selectNatureOfIssue.splice(selectNatureOfIssue.findIndex(select => select.value.toLocaleLowerCase() === appointment.value.toLocaleLowerCase()), 1)
					}
				}
			)
		}
		this.setState({ natureSelectedIssue: selectedNatures })
	}

	closeModalHandler = (isCancel) => {
		selectNatureOfIssue = []
		this.setState({ isModalOpen: false, sessionIndexForModal: '', natureSelectedIssue: [] })
		this.state.natureIssue.length && this.state.natureIssue.map(nature => {
			selectNatureOfIssue.push({ value: nature.code, label: nature.text })
		})
		isCancel && this.setState({ natureIssueOther: '' })
	}
	handleCSVExport = (sessions) => {
		if (sessions.length > 0) {
			const csvData = sessions.map(e => {
				let natureIssues = e.appointment_nature_of_issue.map(issue => issue.nature_of_issue ? (issue.nature_of_issue.text.toLocaleLowerCase() === "other" ? issue.other_issue_text : issue.nature_of_issue.text) : (issue.label.toLocaleLowerCase() === "other" ? this.state.natureIssueOther : issue.value.toLocaleLowerCase()))

				return (
					{
						[constants.NAME_OF_CLIENT]: e.full_name.toUpperCase(),
						[constants.DATE_TIME_SESSION]: moment(e.date_time).format('DD MMM YYYY hh:mm:ss A')
							.toLocaleString('en-US', {
								hour: 'numeric',
								hour12: true,
							}),
						[constants.PROJECT_TXT]: e.project_name,
						[constants.SUBSIDIARY_NAME_TXT]: e.subsidiary_name,
						[constants.STATUS]: this.state.sessionStatus.sessionStatus[e.appointment_status],
						[constants.NATURE_OF_ISSUE_TXT]: natureIssues.length && natureIssues.join()
					})
			}
			)

			const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
			const fileExtension = '.xlsx';
			const fileName = `Past-Session-Report-${moment(this.state.range[0].startDate).format('DD MMM YYYY')}-${moment(this.state.range[0].endDate).format('DD MMM YYYY')}`;

			const ws = XLXS.utils.json_to_sheet(csvData);
			const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
			const excelBuffer = XLXS.write(wb, { bookType: 'xlsx', type: 'array' });
			const dataSource = new Blob([excelBuffer], { type: fileType });
			fileSaver.saveAs(dataSource, fileName + fileExtension);
			this.setState({ is_csv_download: false })
		} else return false
	}
	exportToCSV = (e) => {
		let startDate = moment(this.state.range[0].startDate.setHours(0, 0, 0, 0)).toISOString()
		let endDate = moment(this.state.range[0].endDate.setHours(23, 59, 59)).toISOString()
		this.setState({ is_csv_download: true })
		this.props.csvSessions(startDate, endDate, this.state.currentPage)
	};

	handleOtherInputChange(otherText) {
		this.setState({ natureIssueOther: otherText.value });
		selectedNaturesPayload.other_issue_text = otherText.value
	}

	handleNatureIssueChange = (selectedOption, action) => {
		if (action && action.action === 'remove-value' && action.removedValue.label.toLocaleLowerCase() === constants.OTHER_TXT) {
			selectedNaturesPayload.other_issue_text = ''
			selectNatureOfIssue.push(action.removedValue)
			this.setState({ isOtherSelected: false, natureIssueOther: '' })

		} else if (action && action.action === 'remove-value') {
			selectNatureOfIssue.push(action.removedValue)
		}

		else if (action && action.action === "select-option") {
			let index = selectNatureOfIssue.findIndex(nature => nature.value.toLocaleLowerCase() === action.option.value.toLocaleLowerCase())
			selectNatureOfIssue.splice(index, 1)
		}

		selectedOption.forEach(
			option => {
				if (option.label.toLocaleLowerCase() === constants.OTHER_TXT) {
					this.setState({ isOtherSelected: true })
				}
			}
		)
		this.setState({ natureSelectedIssue: selectedOption })

	}

	submitIssueNature = (appointmentId) => {
		if (this.state.isOtherSelected && selectedNaturesPayload.other_issue_text === '') {
			Swal.fire({
				type: constants.ERROR_TEXT,
				title: constants.SAAYA_HEALTH_TXT,
				text: constants.OTHER_FIELD_TEXT_ERROR,
			})
		} else if (this.state.natureSelectedIssue.length > 0) {
			Swal.fire({
				title: constants.DELETE_CONFORM_HEADER_TXT,
				text: constants.SESSION_UPDATE_NATURE_CONFIRM_TXT,
				type: constants.TYPE_WARNING,
				reverseButtons: constants.REVERSE_BUTTON_STATUS,
				showCancelButton: constants.SHOW_CANCEL_BUTTON,
				confirmButtonColor: constants.CONFIRM_BUTTON_COLOUR,
				cancelButtonColor: constants.CANCEL_BUTTON_COLOUR,
				cancelButtonText: constants.CANCEL_BUTTON_TEXT,
				confirmButtonText: constants.CONFIRM_BUTTON_TEXT,
			}).then((result) => {
				selectedNaturesPayload.appointment_id = appointmentId;
				selectedNaturesPayload.list_nature_of_issues = [];
				this.state.natureSelectedIssue.forEach(option => {
					if (option.label.toLocaleLowerCase() === constants.OTHER_TXT) {
						selectedNaturesPayload.list_nature_of_issues.push(this.state.natureIssueOther);
					} else {
						selectedNaturesPayload.list_nature_of_issues.push(option.value); 
					}
				});
				this.props.UpdateIssueNature(selectedNaturesPayload)
			}).finally(() => {
				let finalState = this.state.natureSelectedIssue.map(nature => nature.value.toLocaleLowerCase() === constants.OTHER_TXT ? { ...nature, other_issue_text: this.state.natureIssueOther } : nature)
				this.setState(
					prevState => {
						prevState.sessionHistory.session.results[this.state.sessionIndexForModal].appointment_nature_of_issue = finalState
					}

				)
				this.closeModalHandler()
			})
		} else {
			Swal.fire({
				type: constants.ERROR_TEXT,
				title: constants.SAAYA_HEALTH_TXT,
				text: constants.EMPTY_NATURE_TEXT_ERROR,
			})
		}
	}

	handleStatusChange = (selectedOption, appointmentId, i) => {
		Swal.fire({
			title: constants.DELETE_CONFORM_HEADER_TXT,
			text: constants.SESSION_UPDATE_CONFIRM_TXT,
			type: constants.TYPE_WARNING,
			reverseButtons: constants.REVERSE_BUTTON_STATUS,
			showCancelButton: constants.SHOW_CANCEL_BUTTON,
			confirmButtonColor: constants.CONFIRM_BUTTON_COLOUR,
			cancelButtonColor: constants.CANCEL_BUTTON_COLOUR,
			cancelButtonText: constants.CANCEL_BUTTON_TEXT,
			confirmButtonText: constants.CONFIRM_BUTTON_TEXT,
		}).then((result) => {
			let status = selectedOption.value;
			if (result.value) {
				this.props.UpdateSessionHistoryStatus({
					appointment_id: appointmentId,
					inquiry: status.toString()
				})
				this.setState({ currentStatus: { index: i, value: selectedOption.value, isSelected: true } })
			}
		});
	}

	isDateBefore45DaysFunc = (date) => {
		return moment.duration(moment().subtract(45, 'd') - moment(date), 'milliseconds').asDays()
	}

	handlePageClick = (page) => {
		if (page.selected + 1 <= this.state.sessionHistory.session.pages && page.selected + 1 >= 1 && this.state.range[0].endDate === null) {
			this.props.getSessions(page.selected + 1, constants.PAGINATION_ITEMS_COUNT)
			this.setState({ isDateRangeSelected: false })
		} else if (page.selected + 1 <= this.state.sessionHistory.session.pages && page.selected + 1 >= 1) {
			let startDate = moment(this.state.range[0].startDate.setHours(0, 0, 0, 0)).toISOString()
			let endDate = moment(this.state.range[0].endDate.setHours(23, 59, 59)).toISOString()
			this.props.getSessions(page.selected + 1, constants.PAGINATION_ITEMS_COUNT, startDate, endDate)
			this.setState({ isDateRangeSelected: true })
		}
	}

	clearDateRangeFilter = () => {
		this.setState({
			range: [
				{
					startDate: null,
					endDate: null,
					key: 'selection'
				}
			]
		})
		this.props.getSessions(this.state.currentPage, constants.PAGINATION_ITEMS_COUNT)
		this.setState({ isDateRangeSelected: false, isCalendarVisible: false })
	}

	showSessions = () => {
		if (this.state.range[0].endDate === null) {
			this.props.getSessions(this.state.currentPage, constants.PAGINATION_ITEMS_COUNT)
			this.setState({ isDateRangeSelected: false })
		} else {
			let startDate = moment(this.state.range[0].startDate.setHours(0, 0, 0, 0)).toISOString()
			let endDate = moment(this.state.range[0].endDate.setHours(23, 59, 59)).toISOString()
			this.props.getSessions(this.state.currentPage, constants.PAGINATION_ITEMS_COUNT, startDate, endDate)
			this.setState({ isDateRangeSelected: true })
		}

	}

	dateRangeHandler = async (currentRange) => {
		this.setState({ range: currentRange })
	}

	hideCalendar = () => {
		if (rdrElements && rdrMonthAndYearWrapper && rdrElements.length > 0 && rdrMonthAndYearWrapper.length > 0) {
			rdrElements[0].classList.remove("showFlex")
			rdrMonthAndYearWrapper[0].classList.remove("showFlex")
			this.setState({ isCalendarVisible: false })
			rdrElements = ''
			rdrMonthAndYearWrapper = ''
		}
	}
	showCalendar = () => {
		if (!rdrElements || !rdrMonthAndYearWrapper) {
			rdrElements = document.getElementsByClassName("rdrMonths");
			rdrMonthAndYearWrapper = document.getElementsByClassName("rdrMonthAndYearWrapper")
		}
		setTimeout(() => {

			if (rdrElements.length > 0 && rdrMonthAndYearWrapper.length > 0) {
				const targetElement = rdrElements[0];
				const targetElement2 = rdrMonthAndYearWrapper[0];
				targetElement.classList.add("showFlex");
				targetElement2.classList.add("showFlex");
			}
		}, 100); // Adjust the delay as needed
		this.setState({ isCalendarVisible: true })
	}

	render() {
		window.document.addEventListener('click', (event) => {
			if (event.target.closest("#range-picker-my-wrapper")) return
			this.hideCalendar()
		})
		let sessions = []
		if (this.state && this.state.sessionHistory && this.state.sessionHistory.session) {
			sessions = this.state.sessionHistory.session;
		}

		let sessionStatus = {}
		if (this.state && this.state.sessionStatus && this.state.sessionStatus.sessionStatus) {
			sessionStatus = this.state.sessionStatus.sessionStatus;
		}
		if (this.state.sessionHistory.loading === false && this.props.sessionHistoryStatus.loading !== true && this.props.natureIssue.loading !== true) {
			return (
				<div className="sh-layout hoffen-block">
					<HeaderComponent />

					<div className="sh-session-history-list sh-session-history-comp sh-gnrl-width">
						{/* Welcome Note */}
						<div className="sh-gnrl-welcome-note">
							<h2 className="sh-gnrl-welcome">{constants.YOUR_PREVIOUS_SESSIONS.toUpperCase()}</h2>
						</div>
						<div className='d-flex justify-content-center mb-3'>
							<button disabled={this.state.range[0].endDate ? false : true} onClick={this.showSessions} className='sh-gnrl-btn mr-3 col-md-2 col-3 date-filter-btn'>
								{constants.SHOW_RESULT_TEXT}
							</button>
							{this.state.isDateRangeSelected && <button onClick={this.clearDateRangeFilter} className='sh-gnrl-btn col-md-2 col-3 date-filter-btn'>
								{constants.CLEAR_FILTER_TEXT}
							</button>}
							{this.state.isDateRangeSelected && <button onClick={this.exportToCSV} className='ml-3 disabled sh-gnrl-btn col-md-2 col-3 date-filter-btn'>
								{constants.EXPORT_EXCEL_TXT}
							</button>}
						</div>
						<div className='range-picker-my-wrapper' id="range-picker-my-wrapper">
							<span onClick={this.showCalendar} className="range-span">
								<DateRangePicker
									onChange={item => this.dateRangeHandler([item.selection])}
									moveRangeOnFirstSelection={false}
									ranges={this.state.range}
									direction="horizontal"
									rangeColors={['#3257A8', '#3257A8', '#3257A8']}
									startDatePlaceholder="Start date"
									endDatePlaceholder="End date"
								/>
							</span>
						</div>
						{/* Session Div */}
						<div className='sh-sessions-table-container'>
							<div className="sh-gnrl-container sh-sessions-table">
								{sessions.results && sessions.results.length > 0 ? (
									<div className="sh-gnrl-cont-content">
										{/* Header for counsellor */}
										<div className="sh-gnrl-cc-row">
											<div className="sh-gnrl-col-1 sh-mble-col-1">
												<span className="sh-gnrl-cchc-main-head">
													{constants.CLIENT_NAME}
												</span>
											</div>
											<div className="sh-gnrl-col-2 sh-mble-col-3">
												<span className="sh-gnrl-cchc-main-head">{constants.DATE_TIME_SESSION_TEXT}</span>
											</div>
											<div className="sh-gnrl-col-1 sh-mble-col-1">
												<span className="sh-gnrl-cchc-main-head">
													{constants.PROJECT_TXT}
												</span>
											</div>
											<div className="sh-gnrl-col-1 sh-mble-col-1">
												<span className="sh-gnrl-cchc-main-head">
													{constants.SUBSIDIARY_NAME_TXT}
												</span>
											</div>
											<div className="sh-gnrl-col-1 sh-mble-col-1">
												<span className="sh-gnrl-cchc-main-head">
													{constants.STATUS}
												</span>
											</div>
											<div className="sh-gnrl-col-1 sh-mble-col-1">
												<span className="sh-gnrl-cchc-main-head">
													{constants.NATURE_OF_ISSUE_TXT}
												</span>
											</div>
										</div>

										{/* Main content Counsellor */}
										{sessions.results && sessions.results.map((v, i) => {
											return (
												<div className={`sh-gnrl-cc-row sh-session-history-row ${this.isDateBefore45DaysFunc(v.date_time) > 0 ? 'status-45-days-old' : ''} `} key={i}>
													<div className="sh-gnrl-col-1 sh-mble-col-1 sh-session-history-col">
														<span className="sh-gnrl-cchc-main-title">
															{v.full_name.toUpperCase() || constants.NOTE_AVAILABLE_TEXT}
														</span>
													</div>
													<div className="sh-gnrl-col-2 sh-mble-col-3 sh-session-history-when-col">
														<span className="sh-gnrl-cchc-main-title">
															{moment(v.date_time)
																.format(constants.DATE_FORMAT_OFR_MOMENT)
																.toLocaleString(constants.MOMENT_LOCAL_STRING_TYPE, {
																	hour: constants.MOMENT_LOCAL_HOUR_TYPE,
																	hour12: constants.MOMENT_IS_12_HOUR_FORMAT,
																})}
														</span>
													</div>
													<div className="sh-gnrl-col-1 sh-mble-col-1 sh-session-history-col">
														<span className="sh-gnrl-cchc-main-title">
															{v.project_name || constants.NOTE_AVAILABLE_TEXT}
														</span>
													</div>
													<div className="sh-gnrl-col-1 sh-mble-col-1 sh-session-history-col">
														<span className="sh-gnrl-cchc-main-title">
															{v.subsidiary_name || constants.NOTE_AVAILABLE_TEXT}
														</span>
													</div>
													<div className="sh-gnrl-col-1 sh-status-session sh-session-history-col">
														{this.isDateBefore45DaysFunc(v.date_time) < 0 ?
															< Select
																options={selectStatusOptions && selectStatusOptions}
																styles={selectStyles}
																filterOption={(option) => option.data.shouldBeDisplayed !== false}
																onChange={(e) => { this.handleStatusChange(e, v.id, i) }}
																className="sh-select-status"
																value={selectStatusOptions.filter(function (option) {
																	return option.value === v.appointment_status;
																})} />
															: <div className="sh-gnrl-col-1 sh-mble-col-1">
																<span className="sh-gnrl-cchc-main-title sh-old-status">
																	{sessionStatus && sessionStatus[v.appointment_status]}
																</span>
															</div>
														}
													</div>
													<div className="sh-gnrl-col-1 ml-3 sh-status-session sh-session-history-col">
														{v.appointment_nature_of_issue.length > 0 ? <button
															onClick={() => this.openModalHandler(i)}
															className='sh-gnrl-btn sh-add-nature-btn p-3'>
															{v.appointment_nature_of_issue.length} {constants.SELECTED_TXT}
														</button> : <button
															onClick={() => this.openModalHandler(i)}
															className='sh-gnrl-btn sh-add-nature-btn p-3'>
															{constants.SELECT_TXT}
														</button>}
													</div>
												</div>
											);
										})}
									</div>
								) : (
									<h3 className="sh-gnrl-empty-note">{constants.EMPTY_SESSIONS_TEXT}</h3>
								)}
							</div>
						</div>
						{this.state.isModalOpen ?
							<UpdateNaruteOfIssueModal
								natureIssueOther={this.state.natureIssueOther}
								selectNatureOfIssue={selectNatureOfIssue}
								closeModalHandler={this.closeModalHandler}
								handleNatureIssueChange={this.handleNatureIssueChange}
								appointment_id={sessions.results[this.state.sessionIndexForModal].id}
								submitIssueNature={this.submitIssueNature}
								value={this.state.natureSelectedIssue}
								isOtherSelected={this.state.isOtherSelected}
								handleOtherInputChange={this.handleOtherInputChange}
							/> : <div></div>
						}
						<div className='sh-pagination-div'>
							{sessions.results && sessions.results.length &&
								<ReactPaginate
									previousLabel={this.state.isMobileScreen ? constants.PAGINATION_PREVIOUS_LABEL_MOB : constants.PAGINATION_PREVIOUS_LABEL}
									nextLabel={this.state.isMobileScreen ? constants.PAGINATION_NEXT_LABEL_MOB : constants.PAGINATION_NEXT_LABEL}
									breakLabel={constants.PAGINATION_BREAK_LABEL}
									marginPagesDisplayed={constants.PAGINATION_MARGIN_PAGES_DISPLAYED}
									pageCount={sessions.pages}
									pageRangeDisplayed={sessions.pages > 7 ? 5 : 3}
									onPageChange={this.handlePageClick}
									containerClassName={'sh-pagination'}
									pageClassName={'sh-pagination-pages'}
									breakClassName={'sh-pagination-pages'}
									activeClassName={'sh-active-page'}
									previousClassName={'sh-previous sh-pagination-pages'}
									nextClassName={'sh-next sh-pagination-pages'}
									disabledClassName={'sh-disabled-link'}
									forcePage={sessions.currentPage - 1}
								/>
							}
						</div>
					</div>

					<Footer />
				</div>
			);
		} else {
			return <Loading />;
		}
	}
}

function mapStateToProps(state) {
	const { sessionHistory, sessionStatus, natureIssue, sessionHistoryStatus, sessionCSVHistory } = state;
	return {
		sessionHistory,
		sessionStatus,
		natureIssue,
		sessionHistoryStatus,
		sessionCSVHistory
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		getSessions: (pageNum, itemsCount, startDate, endDate) => {
			dispatch(sessionActions.getSessions(pageNum, itemsCount, startDate, endDate));
		},
		csvSessions: (startDate, endDate) => {
			dispatch(sessionActions.csvSessions(startDate, endDate));
		},
		getSessionStatus: () => {
			dispatch(sessionActions.getSessionStatus())
		},
		getNatureIssues: () => {
			dispatch(sessionActions.getNatureIssues())
		},
		UpdateSessionHistoryStatus: (status) => {
			dispatch(sessionActions.UpdateSessionHistoryStatus(status))
		},
		UpdateIssueNature: (nature) => {
			dispatch(sessionActions.UpdateIssueNature(nature))
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionsHistory);



// WEBPACK FOOTER //
// ./src/screens/SessionHistory/index.js